import styled from 'styled-components';
import { FavouriteIcon, FavouriteFilledIcon, mq } from '@kvdbil/components';
import React, { MouseEvent } from 'react';
import { useTranslation } from '~/Locale';
import useProductCardIconsProps from '~/App/shared/components/ProductCard/hooks/useProductCardIconsProps';
import Auction from '~/App/shared/interfaces/Auction';
import { ConditionStatus } from '../../ConditionStatus';

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  position: relative;

  & > span {
    margin-right: 0.5rem;
  }
  & > :last-child {
    margin-right: 0;
  }

  svg {
    font-size: 2rem;
  }

  ${mq('tablet')} {
    margin-bottom: 0.5rem;
    svg {
      font-size: 1.5rem;
    }
  }
`;

const FavouriteIconWrapper = styled.div<{ isFavourite: boolean }>`
  margin-left: auto;
  display: flex;

  ${({ theme, isFavourite }) =>
    isFavourite && `color: ${theme.colors.error.main}`};

  ${({ theme, isFavourite }) =>
    !isFavourite && `:hover { color: ${theme.colors.error.main}`};
`;

export interface Props {
  auction: Auction;
}

const Icons = ({ auction }: Props) => {
  const { t } = useTranslation();

  const { isFavourite, toggleFavourite } = useProductCardIconsProps(auction);

  const handleToggleFavourite = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    toggleFavourite();
  };

  return (
    <Container>
      <ConditionStatus
        variation="CARD"
        condition={auction.processObject.conditionClassification}
      />

      <FavouriteIconWrapper
        data-testid="favourite-icon-wrapper"
        isFavourite={isFavourite}
        onClick={handleToggleFavourite}
      >
        {isFavourite ? (
          <FavouriteFilledIcon
            data-testid="favourite-icon-solid"
            title={t('FILLED_FAVOURITE_ICON_TOOLTIP')}
          />
        ) : (
          <FavouriteIcon
            data-testid="favourite-icon"
            title={t('FAVOURITE_ICON_TOOLTIP')}
          />
        )}
      </FavouriteIconWrapper>
    </Container>
  );
};

export default Icons;
